import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ShellContext } from '@/layout/AppShell';
import TeacherSidebar from './TeacherSidebar';

/**
 * Шелл личного кабинета учителя. Визуально использует те же CSS-классы,
 * что и AppShell у админа (.app + .main + .sidebar) — выглядит идентично.
 *
 * Используем тот же `ShellContext` из AppShell — это позволяет переиспользовать
 * существующие компоненты (Topbar, страницы с `useShell()`) без правок,
 * подменяя только сайдбар на «учительский».
 */
const STORAGE_KEY = 'crm2:tweaks';
const DEFAULT_TWEAKS = {
  theme: 'light',
  density: 'cozy',
  sidebarCompact: false,
};

function loadTweaks() {
  try { return { ...DEFAULT_TWEAKS, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') }; }
  catch { return DEFAULT_TWEAKS; }
}

export default function TeacherShell() {
  const [tweaks, setTweaks] = useState(loadTweaks);

  useEffect(() => {
    document.documentElement.dataset.theme = tweaks.theme;
    document.documentElement.dataset.density = tweaks.density;
  }, [tweaks.theme, tweaks.density]);

  const updateTweak = (key, value) => {
    setTweaks((prev) => {
      const next = { ...prev, [key]: value };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return (
    <ShellContext.Provider value={{ tweaks, updateTweak }}>
      <div className={'app' + (tweaks.sidebarCompact ? ' app--sidebar-compact' : '')}>
        <TeacherSidebar compact={tweaks.sidebarCompact} />
        <div className="main">
          <Outlet />
        </div>
      </div>
    </ShellContext.Provider>
  );
}
